import MediaPlayer from '../../components/player/Player';
import styles from '../../styles/Live.module.scss';

const Player = ({ url, type }) => {
  return (
    <div className={styles.liveContainer}>
      <p className={styles.liveText}>
        {type === 'live' ? 'Telewizja na żywo:' : 'Pogoda:'}
      </p>
      <MediaPlayer url={url} type='stream' />
    </div>
  );
};

export async function getServerSideProps(context) {
  const ip =
    context.req.headers['x-forwarded-for'] ||
    context.req.headers['x-real-ip'] ||
    context.req.connection.remoteAddress;

  let ipString = `?ip=${ip}`;
  const query = context?.params?.name[0];
  if (ip) {
    ipString = `?ip=${ip}`;
  }

  if (query === 'live') {
    const response = await fetch(
      `https://webapi.toya.net.pl/v1/tvtoya/live?ip=${ip}`,
      {
        method: 'GET',
        mode: 'cors',
        headers: { Authorization: 'Basic dHZ0b3lhOkFZVnVmVUFyR2Y3TWtFTnY=' },
      }
    );
    const data = await response.json();
    return { props: { url: 'https://' + data.data.url, type: 'live' } };
  } else if (query === 'pogoda') {
    return {
      props: {
        url: 'http://data.tvtoya.pl/toyatv/multimedia/pogoda/pogoda_dtv.mp4',
        type: 'pogoda',
      },
    };
  }
  return { props: {} };
}

export default Player;
